const wowApp = require('angular').module('wowApp.common');

// Directive
wowApp.component('wowFooter', require('./footer.component').footerControllerComponentDefinition);



// WEBPACK FOOTER //
// ./src/common/footer/index.js